/**
 * Una sola forma de buscar motos en todo el módulo (pedido del 2026-10-30): por NOMBRE (marca, modelo,
 * año, conca, color) y por MATERIAL (código SAP), sin importar tildes, mayúsculas ni el orden de las
 * palabras. «victory 2026», «arizona 60005954» o «velocífero» encuentran lo mismo que escribirlo exacto.
 */

/** Sin tildes, en minúscula y con un solo espacio. */
export const normalizar = (s) => String(s ?? '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase()
  .replace(/\s+/g, ' ')
  .trim()

/** ¿El texto contiene TODAS las palabras de la búsqueda, en cualquier orden? Búsqueda vacía = sí. */
export const coincide = (busqueda, texto) => {
  const palabras = normalizar(busqueda).split(' ').filter(Boolean)
  if (!palabras.length) return true
  const t = normalizar(texto)
  return palabras.every((p) => t.includes(p))
}

/** Todo lo buscable de una moto (fila de precios_grupo): nombre + códigos de material. */
export const textoMoto = (g = {}) => [
  g.marca, g.modelo, g.anio_modelo, g.conca, g.etiqueta, g.materiales_texto,
].filter((x) => x !== null && x !== undefined && x !== '').join(' ')

/** filterOptions para un Autocomplete de motos. `texto` arma lo buscable de cada opción. */
export const filtrarPor = (texto = textoMoto, limite = 200) => (opciones, { inputValue }) => (
  (opciones || []).filter((o) => coincide(inputValue, texto(o))).slice(0, limite)
)
